export default function (obj) {
  if (window.structuredClone != null) {
    return window.structuredClone(obj);
  }
  return JSON.parse(JSON.stringify(obj));
}
